import { Identifiable, Project, ProjectResource, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function transferProjectResourceAllocations(httpClient: HttpClient) {
  return (
    project: Identifiable<Project>,
    from: Identifiable<ProjectResource>,
    to: Identifiable<ProjectResource>,
    tasks: Identifiable<Task>[],
  ) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/projects/${project.uuid}/transfer-allocations`,
        method: HttpMethods.PUT,
        data: {
          source: from.uuid,
          destination: to.uuid,
          tasks: tasks.map((t) => t.uuid),
        },
      })
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { transferProjectResourceAllocations };
